import queryString from 'query-string'
import socketIOClient from 'socket.io-client'
import config from '../../../config/environment'
import store from '../../index'
import { INIT } from './type'
import i18n from '../../../i18n'

const { dispatch } = store

export default async function cardPhoto () {
    const url = window.location.href
    const urlParamsString = url.slice((url.indexOf('?')) + 1)
    const urlParamsObj = queryString.parse(urlParamsString)

    const cardNumber = urlParamsObj.cardNumber || null
    const countryCode = urlParamsObj.countryCode || null
    const scheme = urlParamsObj.scheme || null
    const locale = urlParamsObj.locale || 'en'

    i18n.changeLanguage(urlParamsObj.locale)

    const socket = socketIOClient(config.backendUrl, { transports: ['websocket'] })
    socket.emit('openedCardPhotoPage', { cardNumber })

    dispatch({
        type: INIT,
        cardNumber,
        countryCode,
        scheme,
        locale
    })
}